<script lang="ts" module>
	// Module-scoped guard so a re-mount of the banner (e.g. on HMR) or two
	// rapid clicks can never produce more than one reload. Once we've chosen
	// to reload, we're committed — the page is about to unload anyway.
	let reloading = false;
</script>

<script lang="ts">
	import RefreshCwIcon from '@lucide/svelte/icons/refresh-cw';

	function reload(): void {
		if (reloading) return;
		reloading = true;
		// Ask the waiting SW (if any) to activate, then do a full reload so the
		// new HTML pulls the correct chunk hashes. We don't wait for
		// `controllerchange` — Chrome occasionally drops it when the page is
		// the only controlled client, so the unconditional `location.reload()`
		// is the reliable signal.
		if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
			void navigator.serviceWorker.getRegistration().then((reg) => {
				reg?.waiting?.postMessage({ type: 'SKIP_WAITING' });
			});
		}
		location.reload();
	}
</script>

<div
	class="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg border border-sidebar-border bg-background px-4 py-2.5 shadow-[var(--shadow-card)]"
	role="status"
	aria-live="polite"
>
	<RefreshCwIcon class="size-4 text-primary" />
	<span class="text-sm font-medium text-[color:var(--fg-body)]">
		A new version is available
	</span>
	<button
		type="button"
		onclick={reload}
		class="ml-1 rounded-md bg-primary px-3 py-1 text-xs font-medium text-primary-foreground transition-colors hover:opacity-90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sidebar-ring"
	>
		Reload
	</button>
</div>
